import React from 'react'
import {
  FaUserPlus,
  FaUserSlash,
  FaCompass,
  FaFilter,
  FaChartLine,
  FaEnvelopeOpenText,
  FaUsers,
  FaSearch,
  FaFileSignature,
} from 'react-icons/fa'

const Menus = [
  {
    title: 'Search Hangar',
    icon: <FaSearch fontSize="28px" />,
    topTitle: '',
    url: '/',
  },
  {
    title: 'Contact Recon',
    icon: <FaFilter fontSize="28px" />,
    topTitle: 'GO AHEAD.  FILL YOUR FUNNEL, USERNAME!',
    url: '/recon',
  },
  {
    title: 'Templates',
    icon: <FaEnvelopeOpenText fontSize="28px" />,
    topTitle: 'TODAY IS A GOOD DAY FOR BETTER CUSTOMER CONNECTIONS, USERNAME!',
    url: '/templates',
  },
  {
    title: 'Signature',
    icon: <FaFileSignature fontSize="28px" />,
    topTitle: 'TODAY IS A GOOD DAY FOR BETTER CUSTOMER CONNECTIONS, USERNAME!',
    url: '/signature',
  },
  {
    title: 'Intel Reports',
    icon: <FaChartLine fontSize="28px" />,
    topTitle: 'TODAY IS A GOOD DAY FOR BETTER CUSTOMER CONNECTIONS, USERNAME!',
    url: '/reports',
  },
  {
    title: 'Add Single Contact',
    icon: <FaUserPlus fontSize="28px" />,
    topTitle: 'WOW, YOU HAVE A LOT OF CONNECTIONS!',
    url: '/new-contact',
  },
  {
    title: 'Add Bulk Contacts',
    icon: <FaUsers fontSize="28px" />,
    topTitle: 'CHECK YOU OUT, USERNAME… ADDING CONTACTS LIKE A BOSS!',
    url: '/bulk-import',
  },
  {
    title: 'Do Not Engage',
    icon: <FaUserSlash fontSize="28px" />,
    topTitle: 'TODAY IS A GOOD DAY FOR BETTER CUSTOMER CONNECTIONS, USERNAME!',
    url: '/do-not-engage',
  },
  {
    title: 'My Crew Details',
    icon: <FaCompass fontSize="28px" />,
    topTitle: 'MAKING A LIST, CHECKING IT TWICE',
    url: '/crew-details',
  },
]
export default Menus
